module.exports = __webpack_public_path__ + "img/chat-square-text.183127c1.svg";